import Vue from 'vue'
import Router from 'vue-router'
// import volunteer from '@/components/volunteer'; // 志愿服务地图
import Home from '@/components/Home'; // 正式
// import HomeTest from '@/components/HomeTest'; // 测试
// import Page from '@/components/Page'
// import Report from '@/components/Report'
// import Special from '@/components/Special'; // 专题

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Home', // // 2024版改样式
      component: Home
    },
    // {
    //   path: '/',
    //   name: 'Report',
    //   component: Report
    // },
    // {
    //   path: '/',
    //   name: 'HomeTest', 
    //   component: HomeTest
    // },
    // {
    //   path: '/',
    //   name: 'Special',
    //   component: Special
    // },
    // {
    //   path: '/',
    //   name: 'volunteer', // 志愿部地图
    //   component: volunteer
    // },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js